import {
    Button,
    Card,
    Col,
    Image,
    Input,
    Row,
    Space,
    Spin,
    Typography,
} from "antd";
import { useState } from "react";
import { useFiles } from "../../_actions/app/files";
import { useAIImageGenerator } from "../../_actions/bot";

const { Title } = Typography;

export default function ImageGenerator() {
    const [prompt, setPrompt] = useState("");
    const [fileId, setFileId] = useState(null);

    const { mutate: generateImage, isLoading: isGenerating } =
        useAIImageGenerator((data) => {
            const generated = data?.data?.data;
            if (generated?.id) {
                setFileId(generated.id);
            }
        });

    const { data: fileData, isFetching } = useFiles(
        fileId ? `filter[id][_eq]=${fileId}` : "",
        !!fileId
    );

    const img = fileData?.data?.[0] && {
        id: fileData.data[0].id,
        url: `${process.env.REACT_APP_API_BASE_URL}/assets/${fileData.data[0].id}`,
    };

    const handleGenerate = () => {
        if (!prompt.trim()) return;
        generateImage({
            config: { bg_rm: false, image_style: null },
            prompt,
        });
    };

    return (
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
            <Space
                direction="vertical"
                size={40}
                style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    width: "100%",
                }}
            >
                <Card
                    title={<Title level={4}>AI Image Generator</Title>}
                    style={{ margin: "20px auto" }}
                >
                    <Row gutter={12} align="middle">
                        <Col flex="auto">
                            <Space
                                direction="vertical"
                                size="middle"
                                style={{ width: "100%" }}
                            >
                                <Input.TextArea
                                    rows={2}
                                    value={prompt}
                                    onChange={(e) => setPrompt(e.target.value)}
                                    placeholder="Describe the image you want..."
                                />
                                <Button
                                    type="primary"
                                    loading={isGenerating}
                                    onClick={handleGenerate}
                                >
                                    Generate
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    {(isFetching || isGenerating) && (
                        <Row justify="center" style={{ marginTop: 24 }}>
                            <Spin size="large" />
                        </Row>
                    )}

                    {img && !isFetching && (
                        <Row justify="center" style={{ marginTop: 24 }}>
                            <Image
                                src={img.url}
                                alt="Generated"
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: 500,
                                    objectFit: "contain",
                                }}
                                preview
                            />
                        </Row>
                    )}
                </Card>
            </Space>
        </div>
    );
}
